module.exports = __webpack_public_path__ + "media/images/pc/special_reports/icon_champagne-537ba4652c006a9628a3106cbdef4b2d.png";